import "./App.css";

function App() {
  return (
    <div>
      <p>App</p>
    </div>
  );
}

export default App;
